export type SchedulingUrlConfiguration = {
  schedulingBookingUrl: string
  schedulingCancelUrl: string
  schedulingRescheduleUrl?: string
}
